import React from "react";
import { CCol, CContainer, CRow } from "@coreui/react";
import SectionTitle from "../components/Common/SectionTitle";
import staticData from "../assests/staticData.json";

// Service Import
import ServiceCard from "../components/Common/ServiceCard";
import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";



export default function Services() {
  const { services_list } = staticData;
  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"NDIS Services"}
        text={"Our Services"}
      />
      {/* Service Cards */}
      <section
        className="service-section-wrapper"
        style={{ padding: "60px 0px 60px 0px" }}
      >
        <CContainer>
          <CRow>
            <CCol lg={12}>
              <div className="mt-lg-5 mb-lg-5 mt-0 mb-4">
                <SectionTitle
                  align={"center"}
                  subTitle={"services"}
                  subtitle={true}
                  Title={"what we provide"}
                />
              </div>
            </CCol>
          </CRow>
          <CRow className="justify-content-center">
            {services_list.length > 0 &&
              services_list.map((service) => (
                <CCol lg={4} key={service.id} className="mb-3">
                  <ServiceCard service={service} />
                </CCol>
              ))}
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
